import api from '@/services/api';

class ReportDataService {
  getAll(params) {
    return api.get("/reports/", {params});
  }

  get(id) {
    return api.get(`/reports/get/${id}`);
  }

  create(data) {
    return api.post("/reports/create", data);
  }

  update(id, data) {
    return api.put(`/reports/update/${id}`, data);
  }

  delete(id) {
    return api.delete(`/reports/delete/${id}`);
  }

  findByCPF(cpf_farmer) {
    return api.get(`/reports/search/${cpf_farmer}`);
  }
}

export default new ReportDataService();
